import type { LucideIcon } from "lucide-react";

export function StatCard({
  label,
  value,
  hint,
  tone = "teal",
  icon: Icon
}: {
  label: string;
  value: string;
  hint?: string;
  tone?: "teal" | "amber" | "red" | "blue";
  icon: LucideIcon;
}) {
  return (
    <section className="stat-card">
      <div className={`stat-icon stat-icon-${tone}`}>
        <Icon size={20} strokeWidth={2.2} />
      </div>
      <div className="stat-copy">
        <span>{label}</span>
        <strong>{value}</strong>
        {hint ? <small>{hint}</small> : null}
      </div>
    </section>
  );
}
